/**
 * @fileoverview MonthComparisonReportPage - Page wrapper for month comparison report.
 *
 * @description This page provides the month-to-month comparison report functionality.
 * Allows comparison of two time periods (single months or date ranges) with detailed
 * financial analysis including category balances, transaction types, and overall summaries.
 */
import MonthComparisonReport from '../components/Reports/MonthComparisonReport';
import BackButton from '../components/shared/BackButton';
import styles from './ReportPage.module.css';

/**
 * Month-to-month comparison report page.
 *
 * @param {Object} props - Component props
 * @param {Object} props.budgetInfo - Budget metadata including start month
 * @param {Function} props.onBack - Navigate back handler
 */
function MonthComparisonReportPage({ budgetInfo, onBack }) {
    return (
        <div className={styles.container}>
            <BackButton onClick={onBack} />
            <h1 className={styles.pageTitle}>Month-to-Month Comparison</h1>

            <MonthComparisonReport budgetInfo={budgetInfo} />
        </div>
    );
}

export default MonthComparisonReportPage;
